import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { getIDFromUrl } from '@rossum/api-client';
import { IconLayoutGrid } from '@rossum/ui/icons/tabler';
import { IconButton, SvgIcon, Tooltip } from '@rossum/ui/material';
import { currentDatapointSelector } from '../../../../redux/modules/datapoints/selector';
import { documentNeighborsPath } from '../../../document-neighbors';

type NeighborsButtonProps = {
  pageNumber: number;
  canvasWidth: number;
};

export const NeighborsButton = ({
  pageNumber,
  canvasWidth,
}: NeighborsButtonProps) => {
  const intl = useIntl();
  const location = useLocation();
  const history = useHistory();
  const currentDatapoint = useSelector(currentDatapointSelector);

  const annotationId = getIDFromUrl(location.pathname);

  const handleClick = () => {
    if (annotationId) {
      history.push(
        documentNeighborsPath(
          annotationId,
          pageNumber,
          currentDatapoint?.schemaId
        )
      );
    }
  };

  const buttonSize = Math.min(32, canvasWidth * 0.05);
  const iconSize = buttonSize * 0.6;

  return (
    <foreignObject
      x={8}
      y={8}
      width={buttonSize + 4}
      height={buttonSize + 4}
      style={{ overflow: 'visible' }}
    >
      <Tooltip
        title={intl.formatMessage({
          id: 'components.neighborsDrawer.button.tooltip',
        })}
        placement="right"
      >
        <IconButton
          size="small"
          onClick={handleClick}
          sx={{
            width: buttonSize,
            height: buttonSize,
            bgcolor: 'background.paper',
            boxShadow: 1,
            '&:hover': {
              bgcolor: 'action.hover',
            },
          }}
        >
          <SvgIcon sx={{ fontSize: iconSize }}>
            <IconLayoutGrid />
          </SvgIcon>
        </IconButton>
      </Tooltip>
    </foreignObject>
  );
};
